import { MetricSelection } from './../metric-selection';
import { DashboardEventService } from './../../dashboard/dashboard-event.service';
import { SurvivalHorizonService } from './../../survival-horizon/survival-horizon.service';
import { AmChartsService } from '@amcharts/amcharts3-angular';
import { Component, OnInit, ViewEncapsulation, OnDestroy, ChangeDetectorRef, Input, ChangeDetectionStrategy } from '@angular/core';
import { ForeignOutflowMetric } from './foreign-outflow-metric';
import { TrendMetric } from './../trend-metric/trend-metric';

@Component({
    selector: 'app-foreign-outflow-metric',
    templateUrl: './foreign-outflow-metric.component.html',
    styleUrls: ['./foreign-outflow-metric.component.scss', './../trend-metric/trend-metric.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForeignOutflowMetricComponent implements OnInit, OnDestroy {
    @Input()
    foreignOutflowMetric: ForeignOutflowMetric;

    constructor(private amCharts: AmChartsService,
        private survivalHorizonService: SurvivalHorizonService,
        private dashboardEventService: DashboardEventService,
        private changeDetectorRef: ChangeDetectorRef) {

    }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.changeDetectorRef.detach();
    }

    refreshMetric() {
        this.changeDetectorRef.markForCheck();
    }

    onDrillDown() {
        this.dashboardEventService.metricSelectionSubject.next(
            new MetricSelection('FOREIGN_CCY_BREAKDOWN',
                this.foreignOutflowMetric.currency,
                this.foreignOutflowMetric.metricType,
                this.foreignOutflowMetric.name,
                this.foreignOutflowMetric)
        );
    }
    lightMetricColor(foreignOutflowMetric: ForeignOutflowMetric) {
        if (foreignOutflowMetric.initialized) {
            if (foreignOutflowMetric.netflow < 0) {
                return TrendMetric.C_900[2];
            } else {
                return TrendMetric.C_900[4];
            }
        }
    }
}
